import { ThemeProvider } from "@mui/material";
import React, { ReactElement } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import EditorPage from "./components/layout/editor/editor-page";
import Layouts from "./pages/layouts";
import Projects from "./pages/projects";
import Workspaces from "./pages/workspaces";
import { theme } from "./styles/mui-theme";
import { Routes as RoutesPath } from "./types/enums/routes";

function App(): ReactElement {
  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <Routes>
          <Route path={`${RoutesPath.EDITOR}/:id`} element={<EditorPage />} />
          <Route path={`${RoutesPath.PROJECTS}/:id`} element={<Projects />} />
          <Route path={RoutesPath.WORKSPACES} element={<Workspaces />} />
          <Route path={`${RoutesPath.PROJECT}/:id`} element={<Layouts />} />
          <Route path="*" element={<Workspaces />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
